import { render, staticRenderFns } from "./summary-card-list.vue?vue&type=template&id=5e906f35&scoped=true&"
import script from "./summary-card-list.vue?vue&type=script&lang=js&"
export * from "./summary-card-list.vue?vue&type=script&lang=js&"
import style0 from "./summary-card-list.vue?vue&type=style&index=0&id=5e906f35&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5e906f35",
  null
  
)

export default component.exports